import React from 'react';
import { Row, Col, message, InputNumber, Radio ,Input, Icon, Tooltip} from 'antd'
import { InputType } from './input-const';
import { Select } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars';
import NHUpload from '../NHUpload/index';

const RadioGroup = Radio.Group;

//文件上传默认最大值10M
const defaultFileSize = 10;

/**
 * @author weishihuai
 * @date 2018/8/2
 * @time 14:26
 * @Description: 文件上传控件配置组件
 */
class SettingUpload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      feature: '',                        //原参数json字符串
      fileSize: defaultFileSize,
      featureParams: {
        name: '上传控件',
        size: defaultFileSize,          //上传文件默认限制最大为10M
        fileType: 'image',                //文件类型
        mode: 'file',
        numberLimit: 1,
        type: InputType.UPLOAD,         //控件类型，必须有此属性，用于渲染时期判断控件类型
        required: false,                //是否必须(默认非必填)
        validationValueType: 'array',   //指定async-validator校验时值的类型(默认type是string,文件上传不能使用string,不然会报错form value is not string)
        serviceMark:'',//服务标志，说明是属于哪个服务
        moduleName:'',//模块名称，说明是属于哪个服务的哪个模块
        value:'',//附件主表id
        describe:'',//描述，对上传的附件的一个描述信息
        featureParams:'',//附件主表名，存储该附件对应的主表的名称，主要是为了以后进行追溯
      }
    }
  }

  static defaultProps = {
    initFeature: ''
  };

  //在渲染前调用,可在此最后一次初始化组件状态
  componentWillMount() {
    //将输入控件配置参数设置到状态中
    if (this.props.initFeature) {
      try {
        let initFeature = JSON.parse(this.props.initFeature);
        if (initFeature.type == InputType.UPLOAD) {
          //定义文件上传的参数默认值
          let { required = false, fileType = 'image', size = defaultFileSize } = initFeature;
          const fp = { ...this.state.featureParams };
          fp.required = required;
          fp.fileType = fileType;
          fp.size = size;
          fp.serviceMark = initFeature.serviceMark;
          fp.moduleName = initFeature.moduleName;
          fp.value = initFeature.value;
          fp.describe = initFeature.describe;
          fp.featureParams = initFeature.featureParams;
          fp.templateId = initFeature.templateId;
          fp.templateList = initFeature.templateList;
          fp.accept = initFeature.accept;
          this.setState({
            feature: this.props.initFeature,
            featureParams: fp
          });
        }
      } catch (e) {
        console.log(e);
        message.error('解析控件配置参数出错！');
      }
    } else {
      try {
        let feature = JSON.stringify(this.state.featureParams);
        this.setState({
          feature: feature
        });
      } catch (e) {
        console.log(e);
        message.error('生成控件配置参数出错！');
      }
    }
  }

  //供父组件获取feature
  getFeature = () => {
    return this.state.feature;
  };

  //生成feature参数json字符串
  createFeature = (featureParams) => {
    try {
      let feature = JSON.stringify(featureParams);
      this.setState({
        feature: feature
      });
      this.props.onChange(feature);
    } catch (e) {
      message.error('生成控件配置参数出错！');
    }
  };

  //修改文件上传大小，同步更新控件参数
  handleSizeChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.size = value;
    this.setState({ fileSize: value, featureParams: fp });
    this.createFeature(fp);
  };

  //切换是否必填,同步更新控件参数
  handleRequiredRadioChange = (e) => {
    let required = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.required = required;
    this.setState({
      featureParams: fp
    });
    this.createFeature(fp);
  };

  //切换文件类型,同步更新控件参数
  handleFileTypeRadioChange = (e) => {
    let fileType = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.fileType = fileType;
    fp.mode = 'file'
    if (fileType === 'image') {
      fp.validationValueType = 'array'
    } else {
      fp.validationValueType = 'string'
    }
    this.setState({
      featureParams: fp
    });
    this.createFeature(fp);
  };
  handeModeChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.mode = value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleNumberLimitChange = (value) => {
    const fp = { ...this.state.featureParams };
    fp.numberLimit = value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }

  handleServiceMark=(e)=>{
    let serviceMark = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.serviceMark = serviceMark;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleModuleName=(e)=>{
    let moduleName = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.moduleName = moduleName;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleFjzbid=(e)=>{
    let value = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.value = value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleMs=(e)=>{
    let describe = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.describe = describe;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleFjzbm=(e)=>{
    let fileMainName = e.target.value;
    const fp = { ...this.state.featureParams };
    fp.fileMainName = fileMainName;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  handleTemplateChange = (value,list,listMap) => {
    const fp = { ...this.state.featureParams };
    fp.templateList = [...listMap];
    fp.templateId = value;// 附件模板的附件主表id
    this.setState({ featureParams: fp });
    this.createFeature(fp);
    // console.log(value,list,listMap)
  }

  handleAcceptChange = (e) => {
    const fp = { ...this.state.featureParams };
    fp.accept = e.target.value;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  
  render() {
    const { fileSize, } = this.state;
    let { required, fileType, mode, numberLimit, serviceMark, moduleName, value, describe, fileMainName,templateId,accept } = this.state.featureParams;
    return (
      <Scrollbars style={{height:500}}>
      <div id="input-setting-div">
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>文件上传配置信息</div>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>文件类型</div>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <RadioGroup onChange={this.handleFileTypeRadioChange} value={fileType}>
                <Radio value={'image'}>
                  图片
                              </Radio>
                <Radio value={'file'}>
                  文件
                              </Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>文件上传最大值</div>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <InputNumber size="small"
                min={0}
                formatter={value => `${value}M`}
                parser={value => value.replace('M', '')}
                value={fileSize}
                onChange={this.handleSizeChange}
              />
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>上传模式</div>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <Select style={{ width: 120 }} onChange={this.handeModeChange} value={mode} >
                <Select.Option value='file'>file</Select.Option>
                <Select.Option value='redis'>redis</Select.Option>
                {fileType === 'image' ? <Select.Option value='base64'>base64</Select.Option> : null}
              </Select>
            </Col>
          </Row>
          <Row align='middle' type='flex' style={{ margin: '16px 0px 0px 0px' }}>
            <Col span={8}  >文件上传个数限制：</Col>
            <Col span={16}><InputNumber value={numberLimit} min={1} onChange={this.handleNumberLimitChange} /></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>是否必填</div>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <RadioGroup onChange={this.handleRequiredRadioChange} value={required}>
                <Radio value={false}>
                  非必填
                </Radio>
                <Radio value={true}>
                  必填
                </Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>附件模板 <Tooltip title={'提供给学生上传附件的模板'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row type='flex'>
              <Col span={16}><NHUpload serviceMark='sm-dynamic-form' moduleName='动态表单附件模板' defaultEffective={true} onChange={this.handleTemplateChange} value={templateId}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}><a href='https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept'>文件类型</a></div>
            </Col>
          </Row>
          <Row type='flex'>
              <Col span={16}><Input onChange={this.handleAcceptChange} value={accept}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}><font color='red'>*</font>服务标志 <Tooltip title={'说明是属于哪个服务'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row align='middle' type='flex' >
            <Col span={16}><Input placeholder="请输入服务标志" onChange={this.handleServiceMark} value={serviceMark}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}><font color='red'>*</font>模块名称 <Tooltip title={'说明是属于哪个服务的哪个模块'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row type='flex'>
              <Col span={16}><Input placeholder="请输入模块名称" onChange={this.handleModuleName} value={moduleName}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>附件主表id <Tooltip title={'根据id显示已经有的附件内容'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={16}><Input placeholder="请输入附件主表id" onChange={this.handleFjzbid} value={value}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>附件描述 <Tooltip title={'对上传的附件的一个描述信息'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={16}><Input placeholder="请输入附件描述" onChange={this.handleMs} value={describe}/></Col>
          </Row>
          <Row type="flex">
            <Col>
              <div style={{ margin: "16px 0" }}>附件主表名 <Tooltip title={'存储该附件对应的主表的名称，主要是为了以后进行追溯'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
            </Col>
          </Row>
          <Row type="flex">
              <Col span={16}><Input placeholder="请输入附件主表名" onChange={this.handleFjzbm} value={fileMainName}/></Col>
          </Row>
        </div>
      </Scrollbars>
    )
  }
}

export default SettingUpload;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-upload.js